export default "__VITE_ASSET__BHrrKyfK__"